module.exports = __webpack_public_path__ + "img/logo.00ea42bf.png";